import {
  IsOptional,
} from "class-validator";

import { PlanType } from "@eagerdog/constants";

export class UpdateTariffPlanSubscriptionDto {
  @IsOptional()
  plan_type?: PlanType;

  @IsOptional()
  price_provider_external_id?: string;

  @IsOptional()
  default_payment_method?: string;
}
